import React, { useState, useEffect } from "react";
import {
  Box,
  FormControl,
  Button,
  Alert,
  Paper,
  Tabs,
  Tab,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { styled } from "@mui/material/styles";

import { useLocation, useNavigate } from "react-router-dom";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../../Config/Config";
import { CommonMethods } from "../../components/common/CommonMethods";
import {
  fetchProducts,
  fetchCompanies,
  fetchModules,
  fetchSuiteCase,
  fetchTestCasesfromModule,
} from "../../API/CreateCollectionAPI";
import { deleteProductFIle, getFileData, getTestData, refreshZip } from "../../API/TestDataApi";
import NewDataTab from "./NewDataTab";
import RefreshDataTab from "./RefreshDataTab";
import CustomFunctionTab from "./CustomFunctionTab";
import { HelpIconButton } from "../../components-new/help/help-modal";
import apiFetch from "../../utils/apiFetch";

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3),
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
}));

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#FF6B00",
  color: "#FFFFFF",
  "&:hover": {
    backgroundColor: "#FF8533",
  },
  "&.Mui-disabled": {
    backgroundColor: "#FFB74D",
    color: "#FFFFFF",
  },
}));

const ControlsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  flexWrap: "wrap",
  marginBottom: theme.spacing(3),
  backgroundColor: "#FFFFFF",
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  border: "1px solid #FFE0B2",
  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
}));

const FormControlWrapper = styled(FormControl)(({ theme }) => ({
  flex: 1,
  minWidth: "300px",
  maxWidth: "300px",
  width: "300px",
}));

const ButtonContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  alignItems: "flex-end",
}));

const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: "1px solid #e8e8e8",
  "& .MuiTabs-indicator": {
    backgroundColor: "#FF6B00",
    height: 3,
  },
  "& .MuiTab-root": {
    textTransform: "none",
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    color: "#666666",
    "&:hover": {
      color: "#FF6B00",
      opacity: 1,
    },
    "&.Mui-selected": {
      color: "#FF6B00",
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: "none",
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.pxToRem(15),
  marginRight: theme.spacing(1),
  color: "#666666",
  "&.Mui-selected": {
    color: "#FF6B00",
    fontWeight: theme.typography.fontWeightMedium,
  },
}));

const TestDataPage = () => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const navigate = useNavigate();
  const path = useLocation().pathname;
  const [companyId, setCompanyId] = useState();
  const [productList, setProductList] = useState([]);
  const [moduleList, setModuleList] = useState([]);
  const [module, setModule] = useState("");
  const [product, setProduct] = useState("");
  const [tableData, setTableData] = useState([]);
  const [selectedFile, setSelectedFile] = useState({
    file: "",
    filename: "",
  });
  const [suiteCaseList, setSuiteCaseList] = useState([]);
  const [suiteId, setSuiteId] = useState("");
  const [testCaseList, setTestCaseList] = useState([]);
  const [idTestCase, setIdTestCase] = useState("");
  const [selectedFileDropdown, setSelectedFileDropdown] = useState([]);
  const [openAlert, setOpenAlert] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [value, setValue] = useState(0);
  const [formDataTable, setFormDataTable] = useState([]);
  const [refreshDataTable, setRefreshDataTable] = useState([]);
  const [formCustomDataTable, setFormCustomDataTable] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [refreshTableData, setRefreshTableData] = useState([]);
  const [uploadnew, setUploadNew] = useState({
    file: "",
    filename: "",
  });
  const [uploadNewCustom, setUploadNewCustom] = useState({
    file: "",
    filename: "",
  });
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [refreshStatus, setRefreshStatus] = useState("");
  const [refreshCompleted, setRefreshCompleted] = useState(false);
  const [showChooseFile, setShowChooseFile] = useState(false);
  const [tabValue, setTabValue] = useState(0);

  // New state for refresh data tab
  const [company, setCompany] = useState("");
  const [companyList, setCompanyList] = useState([]);
  const [testCase, setTestCase] = useState("");

  const tableColumns = [
    { name: "Testcase", id: "TestCase", width: "15%", align: "center", colspan: 1 },
    { name: "Testcase Desc", id: "Testcase Desc", width: "14%", align: "center", colspan: 2 },
    { name: "Step Number", id: "Stepnumber", width: "15%", align: "center", colspan: 1 },
    { name: "Step Description", id: "stepdescription", width: "10%", align: "center", colspan: 1 },
    { name: "Filename", id: "Filename", width: "20%", align: "center", colspan: 3 },
    { name: "Filefield", id: "Filefield", width: "20%", align: "center", colspan: 1 },
    { name: "Status", id: "Status", width: "10%", align: "center", colspan: 2 },
  ];

  const fileInfoColumns = [
    { name: "File Name", id: "FileName", width: "30%", align: "left", colspan: 1 },
    { name: "Last Modified", id: "LastModified", width: "40%", align: "center", colspan: 1 },
    { name: "FileSize", id: "FileSize", width: "25%", align: "center", colspan: 1 },
  ];

  useEffect(() => {
    getProduct();
    getCompany();
  }, []);

  const getCompany = async () => {
    try {
      const response = await fetchCompanies();
      console.log("Company API Response:", response);
      if (response?.data?.status === 200) {
        const companies = response.data.data || [];
        console.log("Processed companies:", companies);
        setCompanyList(companies);
      } else {
        console.log("No companies found or error in response");
        setCompanyList([]);
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
      setCompanyList([]);
    }
  };

  const fetchFileData = async (productId) => {
    try {
      console.log("fetchFileData called with productId:", productId);
      const response = await getFileData(productId);
      console.log("getFileData response:", response);
      if (response.status === 200) {
        if (response.data.message === "fail") {
          CommonMethods(navigate);
        } else {
          console.log("Setting form data table with:", response.data);
          setFormDataTable(response.data);
        }
      }
    } catch (error) {
      console.error("fetchFileData error:", error);
    }
  };

  useEffect(() => {
    if (product) {
      fetchFileData(product);
    }
  }, [product]);

  const getProduct = async () => {
    try {
      console.log("Fetching products...");
      const response = await fetchProducts();
      console.log("Products response:", response);
      if (response.status === 200) {
        if (response.data.message === "fail") {
          CommonMethods(navigate);
        } else {
          console.log("Setting product list:", response.data);
          setProductList(response.data);
        }
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const getModules = async (id) => {
    try {
      const response = await fetchModules(id);
      if (response.status === 200) {
        if (response.data.message === "fail") {
          CommonMethods(navigate);
        } else {
          setModuleList(response.data);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const selectedProduct = async (event) => {
    setProduct(event.target.value);
    setModule("");
    setModuleList([]);
    setTableData([]);
    await fetchFileData(event.target.value);
  };

  const selectedModule = (event) => {
    setModule(event.target.value);
    setSuiteId("");
    setSuiteCaseList([]);
    setTableData([]);
    getSuiteCase(event.target.value);
  };

  const selectedSuite = (event) => {
    setSuiteId(event.target.value);
    setTestCaseList([]);
    setIdTestCase("");
    setTableData([]);
    const selectedSuiteData = suiteCaseList.find((item) => item.idtestcases === event.target.value);
    if (selectedSuiteData) {
      setTestCaseList(selectedSuiteData.list);
    }
  };

  const selectedTestCase = (event) => {
    setIdTestCase(event.target.value);
    setTableData([]);
    getTestCasefromModule(event.target.value);
  };

  const getSuiteCase = async (id) => {
    try {
      const response = await fetchSuiteCase(id);
      if (response.status === 200) {
        if (response.data.message === "fail") {
          CommonMethods(navigate);
        } else {
          formateSuiteprops(response.data);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const formateSuiteprops = (data) => {
    setSuiteCaseList(
      data.map((item) => ({
        ...item[0],
        list: item[0].list.map((subitem) => subitem.testcases[0]),
      })),
    );
  };

  const getTestCasefromModule = async (id) => {
    try {
      const response = await fetchTestCasesfromModule(id);
      if (response.status === 200) {
        if (response.data.message === "fail") {
          CommonMethods(navigate);
        } else {
          setTestCaseList(response.data);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCheckboxToggle = (event, obj) => {
    const { checked } = event.target;
    if (checked) {
      setSelectedData(selectedData.concat(obj.FileName));
      setSelectedItems(selectedItems.concat(obj));
    } else {
      setSelectedData(selectedData.filter((el) => el !== obj.FileName));
      setSelectedItems(selectedItems.filter((el) => el.FileName !== obj.FileName));
    }
  };

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile({
        file: e.target.files,
        filename: file.name,
      });
    }
  };

  const getRefreshZip = async () => {
    try {
      const response = await refreshZip(product);
      if (response.status === 200) {
        if (response.data.message === "fail") {
          CommonMethods(navigate);
        } else {
          setRefreshTable(false);
          setRefreshTableData(response.data.detail);
          setRefreshStatus(response.data);
          setRefreshCompleted(true);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleUploadFile = async () => {
    if (!selectedFile.file[0]) return;

    try {
      console.log("Starting file upload...");
      const response = await apiFetch(
        `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=uploadTestDataFile&companyid=${temp.companyid}&prodid=${product}&fileName=${selectedFile.file[0].name}`,
        {
          method: "POST",
          body: selectedFile.file[0],
          headers: {
            "content-type": selectedFile.file[0].type,
            "content-length": `${selectedFile.file[0].size}`,
          },
        },
      );

      let data;
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        data = await response.json();
      } else {
        data = await response.text();
      }

      console.log("Upload response:", data);

      if (response.status === 200) {
        if (typeof data === "object" && data.message === "fail") {
          CommonMethods(navigate);
        } else {
          console.log("Upload successful, refreshing data...");
          setSelectedFile({ file: "", filename: "" });
          setOpenAlert(true);

          // Refresh the data using fetchFileData
          await fetchFileData(product);
        }
      }
    } catch (error) {
      console.error("Upload error:", error);
    }
  };

  const getFileNewData = async (product) => {
    try {
      const response = await getFileData(product);
      if (response.status === 200) {
        if (response.data.message === "fail") {
          CommonMethods(navigate);
        } else {
          setFormDataTable(response.data);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleDeleteFiles = async () => {
    if (selectedItems.length === 0) return;

    try {
      const response = await deleteProductFIle(selectedItems);
      if (response.status === 200) {
        if (response.data.message === "fail") {
          CommonMethods(navigate);
        } else {
          // Refresh the file list after successful deletion
          fetchFileData(product);
          setSelectedItems([]);
          setSelectedData([]);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getData = async (product) => {
    try {
      const response = await getTestData(temp.companyid, product, module, idTestCase, suiteId);
      if (response.status === 200 && response.data.message !== "fail") {
        setRefreshDataTable(Array.isArray(response.data) ? response.data : []);
      } else {
        setRefreshDataTable([]);
      }
    } catch (error) {
      console.error("Error fetching test data:", error);
      setRefreshDataTable([]);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setSelectedItems([]);
    setSelectedData([]);
    setSelectedFile({ file: "", filename: "" });
    setFormDataTable([]);
  };

  const handleCloseSnackbar = () => {
    setOpenAlert(false);
  };

  const handleDeleteClick = () => {
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = async () => {
    setDeleteDialogOpen(false);
    await handleDeleteFiles();
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return "0 KB";
    const kb = Math.round(bytes / 1024);
    return `${kb} KB`;
  };

  const handleUploadButton = async () => {
    if (!selectedFile.file[0]) return;

    try {
      console.log("Starting file upload...");
      const response = await apiFetch(
        `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=uploadTestDataFile&companyid=${temp.companyid}&prodid=${product}&fileName=${selectedFile.file[0].name}`,
        {
          method: "POST",
          body: selectedFile.file[0],
          headers: {
            "content-type": selectedFile.file[0].type,
            "content-length": `${selectedFile.file[0].size}`,
          },
        },
      );

      let data;
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        data = await response.json();
      } else {
        data = await response.text();
      }

      console.log("Upload response:", data);

      if (response.status === 200) {
        if (typeof data === "object" && data.message === "fail") {
          CommonMethods(navigate);
        } else {
          console.log("Upload successful, refreshing data...");
          setSelectedFile({ file: "", filename: "" });
          setOpenAlert(true);

          // Refresh the data using fetchFileData
          await fetchFileData(product);
        }
      }
    } catch (error) {
      console.error("Upload error:", error);
    }
  };

  return (
    <Box sx={{ width: "100%", p: 3 }}>
      <StyledTabs value={tabValue} onChange={handleTabChange}>
        <StyledTab label="New Data" />
        <StyledTab label="Refresh Data" />
        <StyledTab label="Custom Function" />
        <Box sx={{ ml: "auto" }}>
          <HelpIconButton path={path} />
        </Box>
      </StyledTabs>

      <Box sx={{ mt: 3 }}>
        {tabValue === 0 && <NewDataTab />}
        {tabValue === 1 && (
          <RefreshDataTab
            product={product}
            productList={productList}
            selectedProduct={(e) => {
              setProduct(e.target.value);
              if (e.target.value) {
                getModules(e.target.value);
              }
            }}
            selectedItems={selectedItems}
            selectedData={selectedData}
            handleCheckboxToggle={handleCheckboxToggle}
            handleFileInputChange={handleFileInputChange}
            selectedFile={selectedFile}
            handleUploadFile={handleUploadFile}
            formDataTable={refreshDataTable}
            handleDeleteClick={handleDeleteClick}
            handleRefreshTable={() => getData(product)}
            fileInfoColumns={fileInfoColumns}
            formatFileSize={formatFileSize}
            setSelectedFile={setSelectedFile}
            setSelectedItems={setSelectedItems}
            setSelectedData={setSelectedData}
            module={module}
            moduleList={moduleList}
            selectedModule={(e) => {
              setModule(e.target.value);
              if (e.target.value) {
                getTestCasefromModule(e.target.value);
              }
            }}
            testCase={idTestCase}
            testCaseList={testCaseList}
            selectedTestCase={(e) => setIdTestCase(e.target.value)}
            clearFilters={() => {
              setProduct("");
              setModule("");
              setIdTestCase("");
              setRefreshDataTable([]);
            }}
            getData={getData}
          />
        )}

        {tabValue === 2 && <CustomFunctionTab />}
      </Box>

      <Snackbar
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert onClose={handleCloseSnackbar} severity="success">
          File uploaded successfully
        </Alert>
      </Snackbar>

      <Dialog open={deleteDialogOpen} onClose={handleDeleteCancel}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>Are you sure you want to delete the selected files?</DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel}>Cancel</Button>
          <Button onClick={handleDeleteConfirm} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default TestDataPage;
